var chunkMapping = {
	"1500": [
		1500
	],
	"1757": [
		1757
	],
	"3140": [
		3140
	],
	"4607": [
		4607
	],
	"4787": [
		4787
	],
	"6183": [
		6183
	],
	"6871": [
		6871
	],
	"7124": [
		7124
	],
	"7150": [
		4728,
		5745
	],
	"7733": [
		7733
	],
	"8341": [
		8341
	],
	"8548": [
		8548
	],
	"8699": [
		8699
	],
	"9031": [
		9031
	],
	"9081": [
		9081
	],
	"9637": [
		9637
	],
	"9739": [
		98
	],
	"9822": [
		9822
	]
};
var idToExternalAndNameMapping = {
	"98": [
		"default",
		"./helper",
		2070
	],
	"1500": [
		"default",
		"./EmailPreferences",
		2070
	],
	"1757": [
		"default",
		"./DevBusTOI",
		2070
	],
	"3140": [
		"default",
		"./Industry",
		2070
	],
	"4607": [
		"default",
		"./Organization",
		2070
	],
	"4728": [
		"default",
		"./index",
		2955
	],
	"4787": [
		"default",
		"./Location",
		2070
	],
	"5745": [
		"default",
		"./privacy-portal-menu",
		2955
	],
	"6183": [
		"default",
		"./DeleteData",
		2070
	],
	"6871": [
		"default",
		"./PreferredLanguage",
		2070
	],
	"7124": [
		"default",
		"./ProfileName",
		2070
	],
	"7733": [
		"default",
		"./InterestBasedAds",
		2070
	],
	"8341": [
		"default",
		"./Unsubscribe",
		2070
	],
	"8548": [
		"default",
		"./UnsubscribeFeedback",
		2070
	],
	"8699": [
		"default",
		"./JobRole",
		2070
	],
	"9031": [
		"default",
		"./GamingTOI",
		2070
	],
	"9081": [
		"default",
		"./CompleteYourProfile",
		2070
	],
	"9637": [
		"default",
		"./RequestData",
		2070
	],
	"9822": [
		"default",
		"./UnsubscribeConfirmation",
		2070
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}